import { hoverNavLinks } from "./DarkeningNav.js";
import { toggleMenu } from "./menu.js";
import { showModalWindow } from "./modalWindow.js";
import { closeMenu } from "./menu.js";
//import { toKnowHeaderHeight } from "./navigation.js";
import { scrollTo } from "./navigation.js";
import { PROJECTS_LIST } from "./PROJECTS_LIST.js";
import { addProjectsToHTML } from "./projects.js";
import { stickyNavObserver } from "./navigation.js";
import { showProjects } from "./projects.js";
import { setFeatureSummaryRotate } from "./feature.js";
import { openMenuFeatures } from "./feature.js";
import { changeTheme } from "./changingTheme.js";
import { checkThemeFromLocalStorage } from "./changingTheme.js";
import surfacingSections from "./surfacingSections.js";
import createAllFeatures from "./features.js";
import { FEATURES_LIST } from "./FEATURES_LIST.js";

// CONSTANTS

const allProjectsBtn = document.querySelector(".jsOnlyAllProjects");
const personProjectsBtn = document.querySelector(".jsOnlyPersonProjects");
const trainingProjectsBtn = document.querySelector(".jsOnlyTrainingProjects");

// PRELOAD IMAGE OF MODALWINDOW

export let preloadedImage;

// Функция для проверки поддержки WebP
export function supportsWebP() {
  const canvas = document.createElement("canvas");
  if (!canvas.getContext || !canvas.getContext("2d")) {
    return false;
  }
  return canvas.toDataURL("image/webp").indexOf("data:image/webp") === 0;
}

window.onload = function () {
  // Определяем устройство и загружаем соответствующее изображение
  const isWebPSupported = supportsWebP();
  const pixelRatio = window.devicePixelRatio; // Получаем коэффициент пикселей

  const firstProjectsBtn = document.getElementById("all-ptojects");
  firstProjectsBtn.checked = true;

  let imageSuffix = "";
  if (pixelRatio >= 4) {
    imageSuffix = "4x"; // Retina 4x
  } else if (pixelRatio >= 3) {
    imageSuffix = "3x"; // Retina 3x
  } else if (pixelRatio >= 2) {
    imageSuffix = "2x"; // Retina 2x
  } else {
    imageSuffix = ""; // no Retina
  }

  if (window.matchMedia("(min-width: 1280px)").matches) {
    preloadedImage = new Image();
    preloadedImage.src = isWebPSupported
      ? `./img/CollegeGradesDesk${imageSuffix}.webp`
      : `./img/CollegeGradesDesk${imageSuffix}.jpg`; // Desktops
  } else if (window.matchMedia("(min-width: 768px)").matches) {
    preloadedImage = new Image();
    preloadedImage.src = isWebPSupported
      ? `./img/CollegeGradesTablet${imageSuffix}.webp`
      : `./img/CollegeGradesTablet${imageSuffix}.jpg`; // Tablets
  } else {
    preloadedImage = new Image();
    preloadedImage.src = isWebPSupported
      ? `./img/CollegeGradesMobile${imageSuffix}.webp`
      : `./img/CollegeGradesMobile${imageSuffix}.jpg`; // Mobiles
  }
};

// MENU
const main = document.querySelector(".main");
const menu = document.querySelector(".nav__list");
const btnMenu = document.querySelector(".nav__btn-menu");
const header = document.querySelector(".header__container");

// (function () {
//   main.style.paddingTop = `calc(3em)`;
// })();

(function () {
  btnMenu.style.visibility = "visible";
})();

btnMenu.addEventListener("click", toggleMenu);

// closeMenu();

// DARKENING NAVIGATION
if (window.innerWidth >= 768) {
  header.addEventListener("mouseover", hoverNavLinks.bind("0.4"));
  header.addEventListener("mouseout", hoverNavLinks.bind("1"));
}

// SCROLLING TO SECTIONS FROM NAVIGATION

const btnList = document.querySelector(".nav__list");

btnList.addEventListener("click", function (e) {
  closeMenu();
  scrollTo(e);
});

// STICKY NAVIGATION
const bioSect = document.querySelector(".bio");

stickyNavObserver.observe(bioSect);

// MODAL WINDOWS
const body = document.querySelector(".body");
const btnDisploma = document.querySelector(".js-education__btn-click");

const modalWindow = document.querySelector(".modal");
const overlay = document.querySelector(".overlay");
const btnCloseModal = document.querySelector(".modal__btn");

const hideModalWindow = function () {
  overlay.classList.remove("jsOverlay");
  closeMenu();
  modalWindow.close();
};

btnDisploma.addEventListener("click", function () {
  showModalWindow("CollegeGrades", "Мое фото");
});
overlay.addEventListener("click", hideModalWindow);
btnCloseModal.addEventListener("click", hideModalWindow);

//PROJECTS_LIST

addProjectsToHTML(PROJECTS_LIST);

const allProjects = document.querySelectorAll(".projects__item");

// SET NUMBER OF PROJECTS INTO THE PROJECTS BTNS

allProjectsBtn.innerHTML = `Все проекты (${allProjects.length})`;
personProjectsBtn.innerHTML = `Личные проекты (${
  document.querySelectorAll(".jsPersonProject").length
})`;
trainingProjectsBtn.innerHTML = `Тренировка навыков (${
  document.querySelectorAll(".jsTrainingProject").length
})`;

// PROJECTS__BUTTONS
const btnsProjects = document.querySelector(".projects__btn-list");

btnsProjects.addEventListener("click", function (e) {
  const btn = e.target;
  if (!btn.closest(".projects__btn")) return;
  if (btn.closest(".jsOnlyAllProjects"))
    return showProjects(allProjects, "projects__item");
  if (btn.closest(".jsOnlyPersonProjects"))
    return showProjects(allProjects, "jsPersonProject");
  if (btn.closest(".jsOnlyTrainingProjects"))
    showProjects(allProjects, "jsTrainingProject");
});

// CREATING ALL FEATURES

createAllFeatures(FEATURES_LIST);

// ROTATE FOR FEATURES

const featureSummary = document.querySelectorAll(".feature__summary");

setFeatureSummaryRotate(featureSummary);

// OPENING FEATURES

const featureBtns = document.querySelectorAll(".feature__button");

featureBtns.forEach((btn) => btn.addEventListener("click", openMenuFeatures));

// CHANGING THEME
checkThemeFromLocalStorage();
const btnsNavList = document.querySelector(".nav__btn-wrapper");

btnsNavList.addEventListener("click", changeTheme);

// SURFACING PARTS
surfacingSections();
